import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import CustomStore from 'devextreme/data/custom_store';
import { DataSourceService } from './data-source-service.ts';

@Injectable({
  providedIn: 'root'
})
export class EventLogService {

  constructor(private http: HttpClient,
    private dataSourceService: DataSourceService
  ) { }

  public apiUrl = `${environment.apiUrl}/eventlogs`;

  async getDataSource(): Promise<CustomStore<any, any>> {
    return this.dataSourceService.getDataSource(this.apiUrl)
  }


}
